<template>
  <div class="modal fade" id="modalBulkGenerateInvoice" role="dialog" data-backdrop="static" data-keyboard="false">
    <div class="modal-dialog modal-dialog-centered modal-scroll" style="max-width: 530px;">
      <div class="modal-content">

        <!-- Modal Header -->
        <div class="modal-header">
          <h4 class="modal-title" style="font-weight: bold;">Generate Bulk Invoices</h4>
          <button type="button" class="close" data-dismiss="modal" @click="resetForm">&times;</button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body px-4 py-3">

          <!-- Section 1: Target Penagihan -->
          <div class="section-card mb-3">
            <div class="section-header mb-3">
              <div class="section-icon">
                <i class="fas fa-file-alt"></i>
              </div>
              <div>
                <div class="section-title">Target Penagihan</div>
                <div class="section-subtitle">Tentukan entitas dan referensi order invoice</div>
              </div>
            </div>

            <div class="mb-3">
              <label class="field-label">Nama Perusahaan</label>
              <multiselect
                class="bulk-invoice-multiselect"
                v-model="selectedCompany"
                :options="companyOptions"
                label="companyName"
                track-by="companyId"
                placeholder="Pilih Nama Perusahaan"
                :allow-empty="true"
                :select-label="''"
                :deselect-label="''"
                :multiple="false"
                :close-on-select="true"
                @input="onCompanyChange"
              ></multiselect>
            </div>

            <div class="mb-1">
              <label class="field-label">Order ID</label>
              <multiselect
                class="bulk-invoice-multiselect"
                v-model="selectedOrderId"
                :options="orderIdOptions"
                label="orderCode"
                track-by="orderCode"
                placeholder="Pilih Order ID"
                :allow-empty="true"
                :select-label="''"
                :deselect-label="''"
              >
              <template slot="option" slot-scope="{ option }">
                  <div class="order-option">
                    <div class="order-option-id">{{ option.orderCode }}</div>
                    <div class="order-option-meta" v-if="option.startRent || option.endRent">
                      <span v-if="option.startRent">Start Rent: {{ option.startRent }}</span>
                      <span v-if="option.startRent && option.endRent"> &bull; </span>
                      <span v-if="option.endRent">End Rent: {{ option.endRent }}</span>
                    </div>
                  </div>
                </template>
                 <template slot="singleLabel" slot-scope="{ option }">
                  <div class="order-selected">
                    <div class="order-selected-id">{{ option.orderCode }}</div>
                    <div class="order-selected-meta" v-if="option.startRent || option.endRent">
                      <span v-if="option.startRent">Start Rent: {{ option.startRent }}</span>
                      <span v-if="option.startRent && option.endRent"> &bull; </span>
                      <span v-if="option.endRent">End Rent: {{ option.endRent }}</span>
                    </div>
                  </div>
                </template>
                </multiselect>
            </div>
          </div>

          <!-- Section 2: Rentang Waktu -->
          <div class="section-card">
            <div class="section-header mb-3">
              <div class="section-icon">
                <i class="fas fa-calendar-alt"></i>
              </div>
              <div>
                <div class="section-title">Rentang Waktu</div>
                <div class="section-subtitle">Atur durasi tagihan yang akan dibuat</div>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <label class="field-label">Start Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="startDate"
                  placeholder="dd/mm/yyyy"
                >
              </div>
              <div class="col-6">
                <label class="field-label">End Date</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="endDate"
                  placeholder="dd/mm/yyyy"
                >
              </div>
            </div>
          </div>

          <!-- Error Message -->
          <div class="mt-2" v-if="errorMessage">
            <span style="color: #FF5D5D; font-size: 14px;">{{ errorMessage }}</span>
          </div>

        </div>

        <!-- Modal Footer -->
        <div class="modal-footer justify-content-end">
          <button class="btn btn-outline-secondary mr-2" @click="resetForm">Reset</button>
          <button
            class="btn btn-primary"
            @click="submitBulkGenerate"
            :disabled="loadingSubmit"
          >
            Submit
            <img src="@/assets/images/2.gif" style="height: 18px; margin-left: 4px;" v-if="loadingSubmit"/>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'ModalBulkGenerateInvoice',
  components: { Multiselect },
  data() {
    return {
      selectedCompany: null,
      selectedOrderId: '',
      orderIdOptions: [],
      companyOptions: [],
      startDate: '',
      endDate: '',
      loadingSubmit: false,
      loadingOrderIds: false,
      errorMessage: '',
    }
  },
  methods: {
    getCompanyForBulk() {
      this.companyOptions = []
      this.$http.post(process.env.GET_COMPANY_INVOICE, {
        companyName: '',
      }, {
        headers: { 'Asani-Token': localStorage.getItem('jwt') }
      })
      .then(res => {
        if (res.data.status === 200) {
          this.companyOptions = res.data.data || []
        }
      })
      .catch(error => {
        const msg = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : error.message
        swal('Sorry', msg, 'error', { button: 'Ok' }).then(() => {
          if (error.response && error.response.data && error.response.data.status === 401) {
            this.$emit('onUnauthorized')
          }
        })
      })
    },
    onCompanyChange() {
      this.selectedOrderId = ''
      this.orderIdOptions = []
      if (!this.selectedCompany) return

      this.loadingOrderIds = true
      this.$http.post(`${process.env.GET_ORDER_INVOICE}`, {
        companyId : this.selectedCompany.companyId
      },{
        headers: { 'Asani-Token': localStorage.getItem('jwt') }
      })
      .then(response => {
        this.loadingOrderIds = false
        if (response.data.status === 200) {
          this.orderIdOptions = response.data.data || []
        } else {
          this.errorMessage = response.data.message
        }
      })
      .catch(error => {
        this.loadingOrderIds = false
        this.errorMessage = error.message
      })
    },
    resetForm() {
      this.selectedCompany = null
      this.selectedOrderId = ''
      this.orderIdOptions = []
      this.startDate = ''
      this.endDate = ''
      this.errorMessage = ''
    },
    submitBulkGenerate() {
      this.errorMessage = ''

      if (!this.selectedCompany) {
        this.errorMessage = 'Nama Perusahaan wajib dipilih.'
        return
      }
      if (!this.startDate || !this.endDate) {
        this.errorMessage = 'Start Date dan End Date wajib diisi.'
        return
      }
      if (new Date(this.startDate) > new Date(this.endDate)) {
        this.errorMessage = 'Start Date tidak boleh lebih besar dari End Date.'
        return
      }

      if(new Date(this.startDate) < new Date(this.selectedOrderId.startRent)) {
        this.errorMessage = 'Start Date tidak boleh sebelum Start Rent.'
        return
      }

      if(new Date(this.endDate) > new Date(this.selectedOrderId.endRent)) {
        this.errorMessage = 'End Date tidak boleh sesudah End Rent.'
        return
      }

      this.loadingSubmit = true
      const payload = {
        companyId: this.selectedCompany.companyId,
        orderId: this.selectedOrderId.orderId,
        startDate: this.startDate,
        endDate: this.endDate,
      }

      this.$http.post(process.env.BULK_GENERATE_INVOICE, payload, {
        headers: { 'Asani-Token': localStorage.getItem('jwt') }
      })
      .then(response => {
        this.loadingSubmit = false
        if (response.data.status !== 200) {
          this.errorMessage = response.data.message
        } else {
          swal('Success', response.data.message, 'success').then(() => {
            this.resetForm()
            $('#modalBulkGenerateInvoice').modal('hide')
            this.$emit('onSuccess')
          })
        }
      })
      .catch(error => {
        this.loadingSubmit = false
        this.errorMessage = (error.response && error.response.data && error.response.data.message) ? error.response.data.message : error.message
        if (error.response && error.response.data && error.response.data.status === 401) {
          this.$emit('onUnauthorized')
        }
      })
    },
  },
  created(){
    this.getCompanyForBulk()
  }
}
</script>


<style>
/* ── Multiselect overrides ── */
.bulk-invoice-multiselect .multiselect__option--highlight {
  background: #E8F0FE !important;
  color: #185FA5 !important;
}
.bulk-invoice-multiselect .multiselect__option--selected.multiselect__option--highlight {
  background: #d0e2fc !important;
  color: #185FA5 !important;
}
.bulk-invoice-multiselect .multiselect__option--selected {
  background: #E8F0FE !important;
  color: #185FA5 !important;
}
</style>

<style scoped>
/* ── Order option in dropdown ── */
.order-option {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px 0;
}

.order-option-id {
  font-size: 13px;
  font-weight: 500;
  color: #2E3646;
}

.order-option-meta {
  font-size: 11px;
  color: #8A94A6;
}

/* ── Selected value (singleLabel) ── */
.order-selected {
  display: flex;
  flex-direction: column;
  gap: 3px;
  line-height: 1.3;
}

.order-selected-id {
  font-size: 13px;
  font-weight: 600;
  color: #2E3646;
}

.order-selected-meta {
  font-size: 11px;
  color: #8A94A6;
}

.section-card {
  background-color: #F8F9FB;
  border-radius: 8px;
  padding: 16px;
}

.section-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E0E0E0;
}

.section-icon {
  width: 36px;
  height: 36px;
  background-color: #E8F0FE;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #2797FB;
  font-size: 16px;
  flex-shrink: 0;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #2E3646;
  line-height: 1.4;
}

.section-subtitle {
  font-size: 12px;
  color: #6C757D;
  margin-top: 2px;
}

.field-label {
  font-size: 13px;
  font-weight: 500;
  color: #2E3646;
  margin-bottom: 6px;
}
</style>


// WEBPACK FOOTER //
// src/components/Invoicing/CustomComponent/ModalBulkGenerateInvoice.vue